/**
 * Shared metrics display component for call list items (traces and evaluations).
 * Displays cost, tokens, latency, date, and user in a consistent grid layout.
 */

// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
// @todo: Migrate to 'Link' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {UserLink} from '@wandb/weave/components/UserLink';
import React from 'react';

import {
  formatCost,
  formatLatency,
  formatRelativeTime,
  formatTokens,
} from '../utils';

interface CallItemMetricsProps {
  cost?: number;
  tokens?: number;
  latency?: number;
  timestamp: string;
  userId?: string;
}

export const CallItemMetrics: React.FC<CallItemMetricsProps> = ({
  cost,
  tokens,
  latency,
  timestamp,
  userId,
}) => {
  const formattedCost = formatCost(cost);
  const formattedTokens = formatTokens(tokens);
  const formattedLatency = formatLatency(latency);
  const formattedDate = formatRelativeTime(timestamp);

  return (
    <div className="flex items-center gap-6 text-xs text-moon-600">
      {/* Cost */}
      {formattedCost && (
        <div className="w-[70px] text-right font-mono">{formattedCost}</div>
      )}

      {/* Tokens */}
      {formattedTokens && (
        <div className="flex w-[60px] items-center justify-end gap-4">
          <Icon
            name="number"
            width={12}
            height={12}
            className="text-moon-400"
          />
          <span className="font-mono">{formattedTokens}</span>
        </div>
      )}

      {/* Latency */}
      {formattedLatency && (
        <div className="w-[50px] text-right font-mono">{formattedLatency}</div>
      )}

      {/* Timestamp */}
      {formattedDate && (
        <div className="w-[60px] text-right text-moon-500">{formattedDate}</div>
      )}

      {/* User avatar */}
      {userId && (
        <div className="flex w-[32px] justify-end">
          <UserLink userId={userId} hasPopover={false} />
        </div>
      )}
    </div>
  );
};
